module.exports = __webpack_public_path__ + "img/editor-icon.8191ddc2.svg";